const CaseFilesStatus = {
    New: 1,
    NotSent: 2,
    Sent: 3,
    ReadyForVisage: 5,
    SentForVisage: 6
}

export default CaseFilesStatus